import axios from 'axios';

import type { TLocalPoststLocationsManualPublish } from '../../types/TBatchGoogleModules';

export const localPoststLocationsManualPublish = async ({
  localPostsLocationId,
  userAccessToken,
  isPublishing,
  user_id,
  user_name,
  user_email,
}: TLocalPoststLocationsManualPublish) => {
  try {
    if (isPublishing) isPublishing(true);

    const apiPath = `
      ${process.env.REACT_APP_SAAS_BATCH_GOOGLE_MODULES}/local-posts-locations/manual-publish/${localPostsLocationId}
    `;

    const requestOptions = {
      headers: {
        Authorization: `Bearer ${userAccessToken}`,
      },
    };

    const { data } = await axios.post(
      apiPath,
      {
        user_id,
        user_name,
        user_email,
      },
      requestOptions,
    );

    return data;
  } catch (err) {
    return null;
  } finally {
    if (isPublishing) isPublishing(false);
  }
};
